import { useState } from 'preact/hooks';
import { flow, replace, fetchNextTask, resetSkipSession, showToast, friendlyError } from '../store.js';
import { __ } from '../i18n.js';
import { TIME_PRESETS } from '../lib/labels.js';
import Icon from '../components/Icon.jsx';

const QUICK_WIN_MINUTES = TIME_PRESETS[0].minutes;

/**
 * Roadmap §6 friction rule: after 2 skips in one sitting, offer a shorter
 * task instead of just handing back another one at the same budget.
 */
export default function InterventionScreen() {
  const [loading, setLoading] = useState(false);

  async function handleQuickWin() {
    if (loading) return;
    setLoading(true);
    try {
      await fetchNextTask(flow.value.categoryId, QUICK_WIN_MINUTES);
      resetSkipSession();
      replace('task', { categoryId: flow.value.categoryId, availableMinutes: QUICK_WIN_MINUTES });
    } catch (err) {
      showToast(friendlyError(err), 'error');
    } finally {
      setLoading(false);
    }
  }

  function handleContinue() {
    resetSkipSession();
    replace('task', { categoryId: flow.value.categoryId, availableMinutes: flow.value.availableMinutes });
  }

  return (
    <div>
      <div class="etm-empty-state">
        <span class="icon">
          <Icon name="psychology" size={44} />
        </span>
        <p>{__('Misschien past een kortere taak beter?', 'etm')}</p>
      </div>

      <button type="button" class="etm-btn etm-btn-primary" disabled={loading} onClick={handleQuickWin}>
        {loading ? __('Bezig…', 'etm') : __('Toon quick wins (15 min)', 'etm')}
      </button>
      <button type="button" class="etm-btn etm-btn-secondary" disabled={loading} onClick={handleContinue}>
        {__('Ga verder zoals gepland', 'etm')}
      </button>
    </div>
  );
}
